// TitleBar.js — v3 (shell architecture, 2026-05-10)
//
// API pública MANTIDA (zero quebra nas 46 pages):
//   title, subtitle, buttons, paths, className
//
// Funcionamento v3:
//   - useEffect popula PageLayoutContext com { title, subtitle, buttons, paths }
//   - cleanup (return) chama setPageInfo(null) ao desmontar
//   - Não renderiza visual in-place (o shell via PageHeader renderiza)
//   - EXCEÇÃO: o Prompt do modalErrorText continua renderizado in-place
//     pois depende de estado local (exportModal) — comportamento inalterado.
//
// IMPORTANTE: NÃO remover o Prompt do modalErrorText sem migrar seu estado
// para um contexto global ou para as pages individuais.

import React, { useEffect, useState } from 'react'
import { usePageLayout } from './layout/PageLayoutProvider'
import { LocalStorageHelper } from '../utils/localStorageHelper'
import Prompt from './Prompt'

function TitleBar({ title, subtitle, buttons, paths, className }) {
  const { setPageInfo } = usePageLayout()
  const [exportModal, setExportModal] = useState(true)

  useEffect(() => {
    setPageInfo({ title, subtitle, buttons, paths, className })
    return () => setPageInfo(null)
  }, [title, subtitle, buttons, paths, className, setPageInfo])

  // Prompt do modalErrorText — renderizado in-place (comportamento inalterado)
  return (
    <Prompt
      visible={
        !!LocalStorageHelper.get('modalErrorText') && exportModal !== null
      }
      title={`Não foi possível obter informações para ${
        LocalStorageHelper.get('modalTitleErrorText') === 'Fazenda'
          ? 'esta'
          : 'este'
      } ${LocalStorageHelper.get('modalTitleErrorText')}`}
      message={LocalStorageHelper.get('modalErrorText')}
      buttons={[
        {
          label: 'Ok',
          onClick: () => {
            LocalStorageHelper.remove('modalErrorText')
            setExportModal(null)
          },
        },
      ]}
    />
  )
}

export default TitleBar
